module.exports = __webpack_public_path__ + "img/savology-wf-6.3e605ce9.jpg";